<script lang="ts">
  import { Link } from 'svelte-routing';
  import { api } from '../lib/api/client';
  import { t } from '../lib/i18n/index.ts';

  // Forgot asks for a password reset link by email (spec 001 FR-018).
  // The server answers the same whether or not the account exists.
  let login = $state('');
  let sent = $state('');
  let error = $state('');
  let busy = $state(false);

  async function ask(e: SubmitEvent) {
    e.preventDefault();
    error = '';
    busy = true;
    try {
      sent = (await api.post<{ message: string }>('/auth/password-reset', { login })).message;
    } catch (err: any) {
      error = err.message;
    } finally {
      busy = false;
    }
  }
</script>

<div class="flex items-center justify-center min-h-full flex-1 p-4">
  <div class="card p-8 w-full max-w-md">
    <h1 class="text-2xl font-bold mb-2 text-center" style="color: var(--theme-accent);">{t('authResetTitle')}</h1>
    {#if sent}
      <p class="text-sm mb-6">{sent}</p>
      <Link to="/login" class="btn btn-secondary w-full block text-center">{t('authBackToSignIn')}</Link>
    {:else}
      <p class="text-sm text-text-muted mb-6">{t('authResetIntro')}</p>
      {#if error}
        <div class="mb-4 p-3 rounded text-sm" style="background-color: var(--theme-error); color: var(--theme-base);">{error}</div>
      {/if}
      <form class="flex flex-col gap-4" onsubmit={ask}>
        <div>
          <label for="login" class="block text-sm font-medium mb-1">{t('authResetLogin')}</label>
          <input id="login" class="input w-full" bind:value={login} required maxlength="254" autocomplete="username" autocapitalize="none" />
        </div>
        <button type="submit" class="btn btn-primary w-full" disabled={busy}>{t('authResetSend')}</button>
      </form>
      <p class="text-sm text-center mt-4"><Link to="/login">{t('authBackToSignIn')}</Link></p>
    {/if}
  </div>
</div>
